module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "de-join-team"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "de-join-team__wrapper"
  }, [_vm._l((_vm.posts), function(post, index) {
    return [_c('div', {
      key: index,
      staticClass: "de-join-team__item"
    }, [_c('div', {
      staticClass: "de-join-team__sector"
    }, [_vm._v(_vm._s(post.acf.sector))]), _vm._v(" "), _c('div', {
      staticClass: "de-join-team__position"
    }, [_vm._v(_vm._s(post.acf.position))]), _vm._v(" "), _c('div', {
      staticClass: "de-join-team__city"
    }, [_vm._v(_vm._s(post.acf.city))]), _vm._v(" "), _c('div', {
      staticClass: "de-join-team__button"
    }, [(post.acf.button_text) ? _c('a', {
      staticClass: "btn default",
      attrs: {
        "href": '/jobs/' + post.slug
      },
      domProps: {
        "innerHTML": _vm._s(post.acf.button_text)
      }
    }) : _vm._e()])])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bb67769","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/JoinTeam.vue
// module id = 329
// module chunks = 0